/**
 * A market stall (lifted from lantern-water's `world.js` `market`): a striped
 * canopy on its frame (`marketCloth`), a slatted counter of produce or books
 * (`marketStock`), the counter top, and a barrel beside it (+2 m east), at the
 * local origin (the stall's centre). Params: `books` (false): the western book
 * stall under green cloth instead of Ada's produce under red.
 */
import * as THREE from 'three';
import { flag } from '../kit.ts';
import { marketCloth, marketStock } from '../market-props.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'market_stall',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const books = flag(ctx, 'books', false);
    const stall = new THREE.Group();
    root.add(stall);
    marketCloth(ctx, stall, books);
    marketStock(ctx, stall, books);
    ctx.box(stall, 0, 0.7, 0.35, 3, 0.13, 1.05, ctx.m.wood);
    ctx.barrel(root, 2, 0, 0.8);
    return { root };
  },
};
